import { createGlobalStyle } from 'styled-components';
import Avenir from './utils/fonts/font-awesome/webfonts/AvenirLTStd-Roman.otf';
import AvenirMedium from './utils/fonts/font-awesome/webfonts/AvenirLTStd-Medium.otf';
import AvenirHeavy from './utils/fonts/font-awesome/webfonts/AvenirLTStd-Heavy.otf';
const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    line-height: 1.5;
  }
  @font-face {
    font-family: 'Avenir';
    font-style: normal;
    font-weight: normal;
    src:
      url('${Avenir}') format('opentype');
  }
  @font-face {
    font-family: 'Avenir-Medium';
    font-style: normal;
    font-weight: normal;
    src:
    url('${AvenirMedium}') format('opentype');
  }
  @font-face {
    font-family: 'Avenir-Heavy';
    font-style: normal;
    font-weight: normal;
    src:
    url('${AvenirHeavy}') format('opentype');
  }
  body {
    font-family: 'Avenir', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  body.fontLoaded {
    font-family: 'Avenir', 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  #app {
    background-color: #fafafa;
    min-height: 100%;
    min-width: 100%;
  }

  p,
  label {
    font-family: Georgia, Times, 'Times New Roman', serif;
    line-height: 1.5em;
  }
`;

export default GlobalStyle;
